import script from "./DailyTripTotalDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyTripTotalDataTable.vue?vue&type=script&setup=true&lang=js"

import "./DailyTripTotalDataTable.vue?vue&type=style&index=0&id=b2235976&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2235976"]])

export default __exports__